module.exports = __webpack_public_path__ + "static/media/staff2.9f29c504.png";